<template>
  <div style="display:none;">
    <b-button
      size="sm"
      :disabled="supportedRegions.length===1"
      variant='light'
      @click="$root.$data.toggleRegionSelection()"
    >{{$root.$data.state.choosedRegion ? $root.$data.state.choosedRegion.name: 'choose region'}}</b-button>

    <b-modal hide-header hide-footer centered
      v-model="$root.$data.state.showRegionSelect">
      <h4 class="text-center">{{$t('available_regions')}}</h4>
      <b-row class="mt-4">
        <b-col v-for="region in supportedRegions" :key="region.code" class="text-center">
          <b-button
            block
            :disabled="!region.available"
            :pressed="$root.$data.state.choosedRegion&&region.code===$root.$data.state.choosedRegion.code"
            size="lg"
            variant='outline-primary'
            @click="selectRegion(region)"
          >{{region.name}}</b-button>
          <span class="text-secondary" v-if="!region.available">Not available yet</span>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import helper from '../../helper'

export default {
  data: () => {
    return {
      supportedRegions: helper.hosts.filter((c) => c.available),
    }
  },
  methods: {
    selectRegion(region) {
      this.$root.$data.setRegion(region)
      this.$root.$data.toggleRegionSelection()
    },
  },
  mounted() {
    // let currentRegion = null
    // try {
    //   const currentRegionCode = localStorage.getItem('region_code')
    //   currentRegion = this.supportedRegions.find(r => r.code === currentRegionCode)
    // } catch (error) {
    //   console.log(error)
    // }

    // if (currentRegion) {
    //   this.$root.$data.setRegion(currentRegion)
    // } else {
    //   this.$root.$data.setRegion(this.supportedRegions[0])
    // }
    const currentRegionCode = localStorage.getItem('region_code')
    const currentRegion = this.supportedRegions.find(r => r.code === currentRegionCode)

    if (currentRegion) {
      this.$root.$data.setRegion(currentRegion)
    } else {
      this.$root.$data.setRegion(this.supportedRegions[0])
    }
  },
}
</script>

<style lang="scss">
.wrap {
  width: 100%;
  height: 100%;
  min-height: 50vh;
}
</style>
